<template>
    <div>
        Loading
    </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
    mixins: [],
    components: {},
    data() {
        return {}
    },
    async mounted() {
        localStorage.setItem("google_code", this.$route.query.code)
        window.close();
    },
    methods: {
        ...mapActions({}),

    }

}
</script>

<style>

</style>
<style scoped>
</style>
